import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/about-ripple.png'
import _imports_1 from '../../images/icon-popup-close.png'


const _withScopeId = n => (_pushScopeId("data-v-10075ba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 가플지우 게시판 "),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 가플지우의 소식을 알아보세요. "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "wave-icon"
  })
], -1))
const _hoisted_3 = { class: "box-banner" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title-wrapper" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "modal-dialog" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "title d-none d-md-block" }
const _hoisted_14 = { class: "title d-md-none" }
const _hoisted_15 = { class: "desc d-none d-md-block" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "desc d-md-none" }
const _hoisted_18 = ["innerHTML"]

import { ref, onMounted } from 'vue';
  import { Modal } from 'bootstrap';
  import bannerData from './data';
  import _ from 'lodash';

  type Banner = {
    image: string;
    popupImage?: string;
    title: string;
    mobileTitle?: string;
    desc: string[];
    mobileDesc?: string[];
    time: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const banners: Banner[] = bannerData.map(item => ({
    ...item,
    mobileTitle: item.mobileTitle || item.title,
    mobileDesc: _.isEmpty(item.mobileDesc) ? item.desc : item.mobileDesc,
    popupImage: item.popupImage || item.image
  }));

  const currentIndex = ref(0);
  const currentBanner = ref<Banner>({ ...banners[currentIndex.value] });
  const textWrapper = ref<HTMLDivElement>();

  const modalRef = ref();
  let modalInstance: Modal;

  function handlePreviewBanner(index: number) {
    currentIndex.value = index;
    currentBanner.value = banners[index];
    handleTriggerDialog(true);
  }

  function handleTriggerDialog(visible: boolean) {
    visible ? modalInstance.show() : modalInstance.hide();
  }

  onMounted(() => {
    modalInstance = new Modal(modalRef.value, {
      keyboard: false,
      backdrop: 'static'
    });
  });

  const on = {
    'shown.bs.modal': () => {
      if (textWrapper.value) {
        textWrapper.value.scrollTop = 0;
      }
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(banners), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item d-flex flex-wrap",
            onClick: ($event: any) => (handlePreviewBanner(index))
          }, [
            _createElementVNode("img", {
              src: item.image,
              class: "banner"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.time), 1)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _mergeProps({
      ref_key: "modalRef",
      ref: modalRef,
      class: "modal fade"
    }, _toHandlers(on)), [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "close-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTriggerDialog(false)))
            }),
            _createElementVNode("img", {
              src: currentBanner.value.popupImage,
              class: "banner"
            }, null, 8, _hoisted_11),
            _createElementVNode("div", {
              ref_key: "textWrapper",
              ref: textWrapper,
              class: "text-wrapper"
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(currentBanner.value.time), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(currentBanner.value.title), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(currentBanner.value.mobileTitle), 1),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBanner.value.desc, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    innerHTML: item
                  }, null, 8, _hoisted_16))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBanner.value.desc, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    innerHTML: item
                  }, null, 8, _hoisted_18))
                }), 128))
              ])
            ], 512)
          ])
        ])
      ])
    ], 16)
  ], 64))
}
}

})